module.exports = "<example-shell\n  exampleId=\"conditional-styles\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Inventory risk\"\n    [columns]=\"inventoryColumns\"\n    [data]=\"inventory\"\n    [conditionalRowStyles]=\"inventoryStyles\"\n    [striped]=\"true\"\n    [highlightOnHover]=\"true\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/conditional-styles/conditional-styles.component.html
// module id = ./src/app/examples/conditional-styles/conditional-styles.component.html
// module chunks = main